import React, { ReactNode } from 'react';
import { StyledArticleContentGrid } from '../../../pages/Article/Styles';
import { BlockContentContext } from '../BlockContent.utils';

interface ContainerSerializerProps {
  children: ReactNode | ReactNode[];
}
export const ContainerSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ children }: ContainerSerializerProps) => <StyledArticleContentGrid>{children}</StyledArticleContentGrid>;
  }
  return ({ children }: ContainerSerializerProps) => children;
};
